import styled, { ThemeProvider } from 'styled-components';
import ProductActionRenderer from 'components/generic/productCTA/ProductActionRenderer';
import type { IProductActionButton } from 'components/generic/productCTA/shared/types';
import useThemeHandler from 'components/shared/productItem/themes/useThemeHandler';

const StyledProductActionRenderer = styled(ProductActionRenderer)`
    width: 100%;
`;

export default function PDPProductActionRenderer({ model, size = 'lg', ...restProps }: IProductActionButton) {
    const { ButtonStyling } = useThemeHandler() as any;

    return (
        <ThemeProvider theme={{ ButtonStyling } as any}>
            <StyledProductActionRenderer model={model} size={size} {...restProps} />
        </ThemeProvider>
    );
}
